import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    company: '',
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Validation
    if (!formData.company || !formData.name || !formData.email) {
      alert('必須項目を入力してください');
      return;
    }

    if (formData.message.length > 500) {
      alert('ご相談内容は500文字以内で入力してください');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('company', formData.company);
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d6qbn6ua739gopmlh83g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          company: '',
          name: '',
          email: '',
          phone: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="doc" id="contact" style={{ borderBottom: 'none' }}>
      <div className="sheet contact-grid">
        <div>
          <p className="sec-label mono">SEC. 05 — お問い合わせ</p>
          <h2>まずは、課題をお聞かせください</h2>
          <p className="sec-intro" style={{ marginBottom: 0 }}>
            「これは自動化できるのか？」という段階のご相談で構いません。
            初回ヒアリングは無料です。売り込みはしません——まず現場の話をお聞きします。
          </p>
        </div>
        <form className="contact" id="contact-form" data-readdy-form onSubmit={handleSubmit}>
          <label htmlFor="company">
            会社名<span className="req">必須</span>
            <input
              type="text"
              id="company"
              name="company"
              required
              value={formData.company}
              onChange={(e) => setFormData({ ...formData, company: e.target.value })}
              placeholder="株式会社〇〇"
            />
          </label>
          <label htmlFor="name">
            お名前<span className="req">必須</span>
            <input
              type="text"
              id="name"
              name="name"
              required
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="山田 太郎"
            />
          </label>
          <label htmlFor="email">
            メールアドレス<span className="req">必須</span>
            <input
              type="email"
              id="email"
              name="email"
              required
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              placeholder="example@company.co.jp"
            />
          </label>
          <label htmlFor="phone">
            電話番号<span className="opt">（任意）</span>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              placeholder="03-1234-5678"
            />
          </label>
          <label htmlFor="message">
            ご相談内容
            <textarea
              id="message"
              name="message"
              rows={5}
              maxLength={500}
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              placeholder="現在の課題や、ご相談されたい内容をお聞かせください（500文字以内）"
            />
          </label>
          <p className="counter">{formData.message.length} / 500文字</p>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? '送信中...' : '無料相談を申し込む'}
          </button>
          {submitStatus === 'success' && (
            <p className="form-status success">
              お問い合わせありがとうございます。ご返信まで暫くお待ち下さい。
            </p>
          )}
          {submitStatus === 'error' && (
            <p className="form-status error">
              送信に失敗しました。もう一度お試しください。
            </p>
          )}
        </form>
      </div>
    </section>
  );
}
